export default function forms() {
	// Find .mena-populate-garage field and return if not found
	if (!$('.mena-populate-garage').length) {
		return;
	}

	// Find the select inside it and attach event listener to return the value in console when changed
	$('.mena-populate-garage select').on('change', function () {

		let email = $(this).val();

		//Add it to the field with class .send-to-email and input inside it
		$('.send-to-email input').val(email);
	});

	// Get the currently selected value and console log it
	let currentSelection = $('.mena-populate-garage select').val();

	// If not empty add it to the field with class .send-to-email and input inside it
	if (currentSelection) {
		$('.send-to-email input').val(currentSelection);
		console.log($('.send-to-email input').val());
	}

}